import { Quill } from '@vueup/vue-quill';
let Parchment = Quill.import('parchment')
class LineHeightAttributor extends Parchment.Attributor.Style { }
const lineHeightStyle = new LineHeightAttributor('lineHeight', 'line-height', {
    scope: Parchment.Scope.INLINE,
    whitelist: ['initial', '1', '1.5','1.75','2', '3', '4', '5']
})
export { lineHeightStyle };

